// extracted by mini-css-extract-plugin
export var headerButton = "headerDoktor-module--headerButton--a5uNs";
export var headerButtonLabel = "headerDoktor-module--headerButtonLabel--CgXAZ";
export var headerContainer = "headerDoktor-module--headerContainer--Mpama";
export var logo = "headerDoktor-module--logo--Sc1w8";